<template>
    <div class="container"></div>
</template>

<script>
    export default {
        name: 'template-component',
        data() {
            return {}
        },
        computed: {},
        methods: {},
        watched: {},
        components: {},
        created() {

        }
    }
</script>

<style lang="less">

</style>
